import * as t from 'io-ts';

import {DataState, RDataState} from './data/dataState';
import {ElectronState} from './electron/electronState';
import {FeatureFlagsState} from './featureFlags/featureFlagsState';
import {MetadataState, RMetadataState} from './metadata/metadataState';
import {DataWithOptimisticUpdatesState, OptimisticUpdate} from './optimisticUpdates/optimisticUpdatesState';
import {PanelsState, RPanelsState} from './panels/panelsState';
import {UpdateState} from './update/updateState';

/*
 * Runtime types.
 */

export const RAppState = t.readonly(
  t.type({
    // Only garbage collect the base data.
    originalData: RDataState,
    metadata: RMetadataState,
    panels: RPanelsState,
  }),
);

/*
 * Types.
 */

export interface AppState extends DataWithOptimisticUpdatesState {
  /** Raw data without optimistic updates. */
  readonly originalData: DataState;
  /** Optimistic updates. */
  readonly optimisticUpdates: OptimisticUpdate[];
  /** Computed data with optimistic updates. */
  readonly data: DataState;
  readonly metadata: MetadataState;
  readonly panels: PanelsState;
  readonly featureFlags: FeatureFlagsState;
  readonly electron: ElectronState | null;
  readonly update: UpdateState;
}
